<template>
    <v-container>

        <tabs-group :value="currentTab" :tabs="tabs" @change="setCurrentTab" />

        <v-row>
            <v-col cols="12">
                <v-row align="center" class="mt-3">
                    <v-col cols="12" md="7" class="title-page">
                        {{ title }}
                    </v-col>
                    <v-col cols="10" md="4">
                        <kimsa-text-field @change="search = $event" :value="search" :placeholder="$t('common.search')"
                            force-value clearable icon="mdi-magnify" :loading="loading" />
                    </v-col>
                    <v-col cols="2" md="1" align="center">
                        <v-btn icon @click="refreshCurrentTab">
                            <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                        <v-divider />
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="12">
                <v-tabs-items v-model="currentTab" class="tabs-items">
                    <v-tab-item value="exercises">
                        <exercises-tab @loading="loading = $event" ref="exercises" />
                    </v-tab-item>
                    <v-tab-item value="blocks">
                        <blocks-tab @loading="loading = $event" ref="blocks" />
                    </v-tab-item>
                    <v-tab-item value="routines">
                        <routines-tab @loading="loading = $event" ref="routines" />
                    </v-tab-item>
                    <v-tab-item value="programs">
                        <programs-tab @loading="loading = $event" ref="programs" />
                    </v-tab-item>
                    <v-tab-item value="prescriptions">
                        <prescriptions-tab @loading="loading = $event" ref="prescriptions" />
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import TabsGroup from '@/components/common/TabsGroup';
import RoutinesTab from '@/components/coach/Tabs/RoutinesTab';
import ProgramsTab from '@/components/coach/Tabs/ProgramsTab';
import ExercisesTab from '@/components/coach/Tabs/ExercisesTab';
import BlocksTab from '@/components/coach/Tabs/BlocksTab';
import PrescriptionsTab from '@/components/coach/Tabs/PrescriptionsTab';
import { mapMutations, mapState } from "vuex";

export default {
    components: { KimsaTextField, TabsGroup, RoutinesTab, ProgramsTab, ExercisesTab, BlocksTab, PrescriptionsTab },
    data() {
        return {
            tabs: [
                { label: this.$t('common.exercises'), value: 'exercises' },
                { label: this.$tc('common.blocks', 2), value: 'blocks' },
                { label: this.$t('common.routines'), value: 'routines' },
                { label: this.$t('common.programs'), value: 'programs' },
                { label: this.$t('common.prescriptions'), value: 'prescriptions' },
            ],
            currentTab: 'exercises',
            search: '',
            loading: false,
        }
    },
    computed: {
        ...mapState(['libraryTab']),
        title(vm = this) {
            return vm.$t(`common.review_your_${vm.currentTab}`)
        },
    },
    async mounted() {
        const vm = this
        if (vm.libraryTab) vm.currentTab = vm.libraryTab
        else vm.setLibraryTab(vm.currentTab)
    },
    methods: {
        ...mapMutations(['setLibraryTab']),
        setCurrentTab(tab) {
            const vm = this;
            vm.currentTab = tab
        },
        refreshCurrentTab() {
            const vm = this
            if (vm.$refs[vm.currentTab]) vm.$refs[vm.currentTab].refresh()
        },
    },
    watch: {
        currentTab(val, oldVal) {
            if (this.$refs[oldVal]) this.$refs[oldVal].setSearch('')
            this.search = ''
            this.setLibraryTab(val)
        },
        search(val) {
            if (this.$refs[this.currentTab]) this.$refs[this.currentTab].setSearch(val)
        },
    }
}
</script>

<style scoped>
.title-page {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
}

.tabs-items {
    background-color: transparent;
    padding-bottom: 16px;
}
</style>
